export default function OpenInExcelPage() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#fff",
      }}
    >
      <div className="login-container">
        <img src="/images/Excel-Logo.png" alt="Modo Imparable" />
        <h2>Abre Modo Imparable desde Excel</h2>
        <p style={{ fontSize: 13, color: "var(--gray-600)", lineHeight: 1.6 }}>
          Este complemento funciona dentro del panel de tareas de Excel.
          Ábrelo desde la pestaña <strong>Inicio &gt; Complementos</strong> en
          Excel para iniciar sesión y ver tus prácticas.
        </p>
        <div className="link" style={{ marginTop: 16, fontSize: 12.5 }}>
          ¿No tienes el complemento instalado?{" "}
          Escríbenos a{" "}
          <a href="mailto:soporte@hazloconexcel.com?subject=Quiero%20instalar%20Modo%20Imparable">
            soporte@hazloconexcel.com
          </a>
          .
        </div>
      </div>
    </div>
  );
}
